import React from 'react'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { useFormatMessage, commonCTAs } from 'lib/localization'

export const GENERAL_MODAL = 'GENERAL_MODAL'

/*
 * use this if you just wanna throw a component into a modal. if you want
 * anything in the way of complex behavior out of your modal, it probably
 * deserves its own modal entry
*/

export const GeneralModal = ({ title, component, confirmText, onConfirm, showCancel, onRequestClose }) => {
  const fm = useFormatMessage()
  const _onConfirm = () => {
    if (onConfirm) {
      onConfirm()
      onRequestClose()
    } else {
      onRequestClose()
    }
  }
  return (
    <ConfirmationDialog
      title={title}
      maxWidth='600px'
      showCancel={!!showCancel}
      onRequestClose={onRequestClose}
      confirmText={confirmText ?? fm(commonCTAs.close)}
      onConfirm={_onConfirm}>
      {component}
    </ConfirmationDialog>
  )
}
